import React from 'react';
import Styles from './styles.module.scss'; // ✅ Use this file

interface QuoteModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const QuoteModal: React.FC<QuoteModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className={Styles.modalOverlay}>
      <div className={Styles.modalContent}>
        <button className={Styles.closeButton} onClick={onClose}>×</button>
        <h2>Request a Quote</h2>
        <form className={Styles.form}>
          <div className={Styles.formGroup}>
            <label>Full Name</label>
            <input type="text" placeholder="Full name" />
          </div>
          <div className={Styles.formGroupRow}>
            <div className={Styles.formGroup}>
              <label>E-mail</label>
              <input type="email" placeholder="Email" />
            </div>
            <div className={Styles.formGroup}>
              <label>Phone Number</label>
              <input type="text" placeholder="Phone number" />
            </div>
          </div>
          <div className={Styles.formGroup}>
            <label>Message</label>
            <textarea placeholder="Message" />
          </div>
          <button type="submit" className={Styles.submitButton}>Submit</button>
        </form>
      </div>
    </div>
  );
};

export default QuoteModal;
